import cn from 'clsx'

import { IconPinLocked } from '@tracklib/kit'
import styles from './disabledoverlay.css'

const DisabledOverlay = ({ className }: { className?: string }) => (
  <div className={cn(styles.disabledOverlay, className)}>
    <IconPinLocked />
    Not available in your region
  </div>
)

export default DisabledOverlay
